// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d21ef7c2","250":"e75b016c","301":"ed22d916","408":"21103fe3","421":"a89c42c5","528":"73e47c85","533":"62865dd1","845":"822000a3"}[chunkId] + ".chunk.js";
};